import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
}

export const LogoMark: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 64 64'
            aria-hidden='true'
            className={cn('size-8 shrink-0', className)}
        >
            <rect width='64' height='64' rx='16' className='fill-primary' />
            <rect x='14' y='36' width='9' height='14' rx='2.5' className='fill-primary-foreground' />
            <rect x='27.5' y='26' width='9' height='24' rx='2.5' className='fill-primary-foreground' />
            <rect x='41' y='14' width='9' height='36' rx='2.5' className='fill-primary-foreground' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            <span className='font-heading text-xl font-bold tracking-tight text-foreground'>
                Framerank
            </span>
        </span>
    )
}
